import { VegaFont } from '@globalpayments/vega-react';
import Log from './Log';
import { log } from './Interfaces';

interface Props {
    logs: log[];
    animate: boolean;
}

const LogTab: React.FC<Props> = ({ logs, animate }) => {
    if (logs.length === 0) {
        return <VegaFont as="p" color="text-secondary" variant="font-h5">No lead status entries available.</VegaFont>;
    }

  return (
    <>
            {logs.map((log, index) => (
                <Log key={index + log.dateUTC} log={log} delay={5 + index} animate={animate} />
            ))}
    </>
    );
};

export default LogTab;